export class AWSTemplets {
    ID:number;
    TEMPLATE_NAME:string;
    SUBJECT:string;
    BODY:string;
    CLIENT_ID:number;
}

